import type { TicketElement } from '../TicketElement'

export class DottedSeparator implements TicketElement {
  padding: number
  lineHeight: number

  constructor({ size = 1, padding = 20 }: { size?: number; padding?: number } = {}) {
    this.padding = padding ?? 20
    this.lineHeight = size ?? 1
  }

  height(): number {
    return this.padding * 2 + this.lineHeight
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): number {
    ctx.fillStyle = 'black'
    ctx.setLineDash([3, 3])
    ctx.moveTo(0, top + this.padding)
    ctx.lineTo(width, top + this.padding)
    ctx.stroke()
    ctx.setLineDash([])
    return this.padding * 2 + this.lineHeight
  }
}
